/** Mirrors `buxus-frontend` `TRAINING_INTRO_TEXT` / `LMS_START_URI`. */
export const TRAINING_INTRO_TEXT =
  'Welcome to the Buxus Training Portal. Please select a training path below.'

export const LMS_START_URI = 'https://lms.buxus.io/start/op/openid'

/** Hybrid POC: hide AR training entry until Unity/web path exists. */
export const SHOW_AR_TRAINING_BUTTON = false
